import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const enumConstructorsConstruct = dictIsSymbol => (
  {enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy)), Data$dGeneric$dRep.NoArguments)]}
);
const enumConstructors = dict => dict.enumConstructors;
const genericUnsafeDecodeEnum = dictGeneric => dictEnumConstructors => opts => {
  const constructors = Foreign$dObject.fromFoldable(Data$dFoldable.foldableArray)(dictEnumConstructors.enumConstructors(opts));
  return value => {
    const tag = Unscramble.decodeString(value);
    const v = Foreign$dObject._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, tag, constructors);
    if (v.tag === "Nothing") { return Unscramble.decodingError("Invalid enum tag value: " + Data$dShow.showStringImpl(tag)); }
    if (v.tag === "Just") { return dictGeneric.to(v._1); }
    $runtime.fail();
  };
};
const enumConstructorsSum = dictEnumConstructors => dictEnumConstructors1 => (
  {
    enumConstructors: opts => Data$dSemigroup.concatArray(Data$dFunctor.arrayMap(Data$dTuple.functorTuple.map(Data$dGeneric$dRep.Inl))(dictEnumConstructors.enumConstructors(opts)))(Data$dFunctor.arrayMap(Data$dTuple.functorTuple.map(Data$dGeneric$dRep.Inr))(dictEnumConstructors1.enumConstructors(opts)))
  }
);
const defaultEnumOptions = {constructorTagTransform: x => x};
export {defaultEnumOptions, enumConstructors, enumConstructorsConstruct, enumConstructorsSum, genericUnsafeDecodeEnum};
